import './icons'

import Accordion from './accordion'
import SectionFilter from './section-filter'
import ButtonScroll from './button-scroll'
import Carousel from './carousel'

import Modals from './modals'

import Search from './search'
import VueComponents from './vue-component'
import GLightbox from 'glightbox'

import '@/scss/base.scss'
import { Thumbs } from 'swiper/modules'

class APP {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[FABER] Base online')

      this.initPage()
      this.initCarousels()
    })
  }

  initPage() {
    this.vueComponents = new VueComponents()
    this.modals = new Modals()
    this.accordion = new Accordion()
    this.sectionFilter = new SectionFilter()
    this.buttonScroll = new ButtonScroll()
    this.search = new Search()
  }

  initCarousels() {
    this.carousels = {
      gallery: new Carousel(
        '.swiper.is-gallery',
        {
          edgeSwipeDetection: 'prevent',
          slidesPerView: 1,
        },
        document,
        'footer .swiper-caption',
      ),
      header: new Carousel('.swiper.is-header', {
        edgeSwipeDetection: 'prevent',
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
        },
        speed: 500,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      }),
      shopThumbs: new Carousel('.swiper.is-shop-header-thumbs', {
        slidesPerView: 2.5,
        spaceBetween: 20,
        breakpoints: {
          769: {
            slidesPerView: 5,
          },
        },
      }),
    }

    this.carousels.shop = new Carousel(
      '.swiper.is-shop-header',
      {
        slidesPerView: 1,
        thumbs: {
          swiper: this.carousels?.shopThumbs?.instance,
          autoScrollOffset: 1,
        },
        navigation: {
          nextEl: '.is-shop-nav > .swiper-button.is-next',
          prevEl: '.is-shop-nav > .swiper-button.is-prev',
        },
      },
      document,
      '.is-shop-caption',
      true,
    )

    const lightboxHTML = `
        <div id="glightbox-body" class="glightbox-container">
          <div class="gloader visible"></div>
          <div class="goverlay"></div>
          <div class="gcontainer">
            <div id="glightbox-slider" class="gslider"></div>
            <button class="gnext gbtn button is-medium is-square is-black is-rounded" tabindex="0" aria-label="Următorul"><span class="icon is-icon-36"><iconify-icon icon="ci:chevron-right-md" noobserver></iconify-icon></span></button>
            <button class="gprev gbtn button is-medium is-square is-black is-rounded" tabindex="1" aria-label="Precedentul"><span class="icon is-icon-36"><iconify-icon icon="ci:chevron-left-md" noobserver></iconify-icon></span></button>
            <button class="gclose gbtn button is-medium is-square is-black is-rounded" tabindex="2" aria-label="Închide"><span class="icon is-icon-24"><iconify-icon icon="ci:close-md" noobserver></iconify-icon></span></button>
          </div>
        </div>`

    const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      lightboxHTML,
    })
  }
}

export default new APP()
